// extracted by mini-css-extract-plugin
export default {"buyerProtection":"buyerProtection_buyerProtection__pvmvq"};